// extracted by mini-css-extract-plugin
export var alertIcon = "_pz-0";